import type { NpcArchetype } from "./contracts.js";
import type { FactionSectorId } from "./world-layout.js";
import type { WorldNpcSpawn } from "./world-locations.js";

interface AlienEncounter {
  templateId: string;
  sectorId: FactionSectorId;
  title: string;
  objectivePoint: { x: number; y: number };
  requiredArchetypes: readonly NpcArchetype[];
  spawns: readonly Omit<WorldNpcSpawn, "sectorId">[];
}

export const ALIEN_ENCOUNTERS = [
  {
    templateId: "concord-kepler-aliens",
    sectorId: "concord-kepler",
    title: "Чужие в поясе Кеплера",
    objectivePoint: { x: 2770, y: 5625 },
    requiredArchetypes: ["alien-scout", "alien-artillery"],
    spawns: [
      { id: "concord-kepler-alien-scout-1", archetype: "alien-scout", x: 2670, y: 5500 },
      { id: "concord-kepler-alien-artillery-2", archetype: "alien-artillery", x: 2870, y: 5750 },
    ],
  },
  {
    templateId: "helion-slag-aliens",
    sectorId: "helion-slag",
    title: "Заглушить разведку чужих",
    objectivePoint: { x: 3950, y: 7220 },
    requiredArchetypes: ["alien-scout", "alien-disruptor"],
    spawns: [
      { id: "helion-slag-alien-scout-1", archetype: "alien-scout", x: 3800, y: 7220 },
      { id: "helion-slag-alien-disruptor-2", archetype: "alien-disruptor", x: 4100, y: 7220 },
    ],
  },
  {
    templateId: "nomads-graveyard-aliens",
    sectorId: "nomads-graveyard",
    title: "Охотники среди остовов",
    objectivePoint: { x: 9260, y: 5525 },
    requiredArchetypes: ["alien-artillery", "alien-disruptor"],
    spawns: [
      { id: "nomads-graveyard-alien-artillery-1", archetype: "alien-artillery", x: 9120, y: 5400 },
      { id: "nomads-graveyard-alien-disruptor-2", archetype: "alien-disruptor", x: 9400, y: 5650 },
    ],
  },
] as const satisfies readonly AlienEncounter[];

export const ALIEN_CONTRACT_TEMPLATE_IDS = ALIEN_ENCOUNTERS.map((encounter) => encounter.templateId);
export type AlienContractTemplateId = (typeof ALIEN_CONTRACT_TEMPLATE_IDS)[number];
export const ALIEN_NPC_SPAWNS: readonly WorldNpcSpawn[] = ALIEN_ENCOUNTERS.flatMap((encounter) =>
  encounter.spawns.map((spawn) => ({ ...spawn, sectorId: encounter.sectorId })),
);
